import React from 'react';
import { useShownNumber, type AgentSource } from './citations';

/**
 * Numbered sources under an answer; numbers match the inline [n] chips. Sources with the same
 * title and no link (knowledge-base documents shown to advisors as "WorldVia knowledge base")
 * share one line: "1, 2, 3. WorldVia knowledge base".
 */
export function SourcesList({ sources }: { sources: AgentSource[] }) {
  const shown = useShownNumber();
  if (!sources.length) return null;
  const rows: Array<{ indices: number[]; source: AgentSource }> = [];
  for (const s of [...sources].sort((a, b) => shown(a.index) - shown(b.index))) {
    const same = !s.url && rows.find((r) => !r.source.url && r.source.title === s.title);
    if (same) same.indices.push(shown(s.index));
    else rows.push({ indices: [shown(s.index)], source: s });
  }
  return (
    <div className="mt-3 border-t border-gray-100 pt-2 dark:border-gray-700">
      <p className="mb-1 text-xs font-medium text-gray-500 dark:text-gray-400">Sources</p>
      <ol className="space-y-0.5 text-xs">
        {rows.map(({ indices, source: s }) => (
          <li key={indices.join('-')} className="flex gap-1.5">
            <span className="shrink-0 text-right text-gray-500 dark:text-gray-400">{indices.join(', ')}.</span>
            {s.url ? (
              <a href={s.url} target="_blank" rel="noopener noreferrer" className="min-w-0 truncate text-orange-700 hover:underline dark:text-orange-300">
                {s.title}
                {s.domain && s.domain !== s.title ? <span className="ml-1 text-gray-400">· {s.domain}</span> : null}
              </a>
            ) : (
              <span className="min-w-0 truncate text-gray-600 dark:text-gray-300">{s.title}</span>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
}
